export default "/images/cloud.svg?6320a388771887c1a0cb0b6cb6bfa0ab";